import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import Filter from "./filter/filter";
import { clearFilters, resetPreviousFid, resetSelectedCard } from "../../../services/reducers/filters";
import { useAppDispatch } from "../../../hooks/useAppDispatch";

const FilterWrapper = () => {
    const { filter } = useParams<{ filter?: string }>();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleBackToFilters = () => {
        navigate('/search');
        dispatch(clearFilters({}));
        dispatch(resetSelectedCard());
        dispatch(resetPreviousFid());
    };

    const filterMapping: Record<string, "Plots" | "InvestmentOpportunities" | "SpacesForRent"> = {
        plt: "Plots",
        invop: "InvestmentOpportunities",
        spc: "SpacesForRent"
    };

    if (!filter || !filterMapping[filter]) {
        return null;
    }

    const filterType = filterMapping[filter];

    return <Filter filterType={filterType} onBack={handleBackToFilters} />;
};

export default FilterWrapper;
